import * as React from 'react';
import Button from '@mui/material/Button';
import {Dialog as MUIDialog, IconButton} from '@mui/material';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {observer} from "mobx-react";

function AlertDialog({title="", content="", acceptHandler=() => {}, disagreeHandler=() => {}, icon, color="primary", dialogState}) {


    const handleClickOpen = () => {
        dialogState.openDialog();
    };

    const handleClose = () => {
        dialogState.closeDialog();
    };

    return (
        <div>
            <IconButton color={color} onClick={handleClickOpen}>
                {icon}
            </IconButton>
            <MUIDialog
                open={dialogState.isOpen()}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {title}
                </DialogTitle>
                {content && <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {content}
                    </DialogContentText>
                </DialogContent>}
                <DialogActions>
                    <Button
                        onClick={handleClose}
                        sx={{ color: 'error.main' }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        autoFocus
                        variant="contained"
                        color="success"
                        onClick={() => {
                            acceptHandler()
                            handleClose()
                        }}
                    >
                        Aceptar
                    </Button>
                </DialogActions>
            </MUIDialog>
        </div>
    );
}

export default observer(AlertDialog)
